module.exports = __webpack_public_path__ + "static/media/Slice6@2x.a9c64ccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/Slice6@2x.png
// module id = 1411
// module chunks = 0